import { render, staticRenderFns } from "./FavoriteComponent.vue?vue&type=template&id=da52431c&scoped=true&"
import script from "./FavoriteComponent.vue?vue&type=script&lang=js&"
export * from "./FavoriteComponent.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteComponent.vue?vue&type=style&index=0&id=da52431c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da52431c",
  null
  
)

export default component.exports